import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 26;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 2.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      personName?.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

interface CustomMultiSelectProps {
  label: string;
  name: string;
  placeholder: string;
  options: Array<string>;
  selectedOption: Array<string>;
  handleChangeOption: (selectedOption: Array<string>) => void;
}

export default function CustomMultiSelect(props: CustomMultiSelectProps) {
    
  const { label, name, placeholder, selectedOption, options } = props;

  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent<typeof selectedOption>) => {
      const {
          target: { value },
      } = event;
      props.handleChangeOption(
          // On autofill we get a stringified value.
          typeof value === 'string' ? value.split(',') : value,
      );
  };
  console.log(selectedOption)
  return (
    <FormControl sx={{ mb: 1, width: '100%' }} size='small'>
      <InputLabel id={`${props.label}-multiple-chip-label`}>{label}</InputLabel>
      <Select
          labelId={`${label}-multiple-chip-label`}
          id={`${label}-multiple-chip`}
          multiple
          name={name}
          placeholder={placeholder}
          value={selectedOption}
          onChange={handleChange}
          input={<OutlinedInput id={`select-multiple-${name}`} label={label} />}
          renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => (
                      <Chip key={value} label={value} />
                  ))}
              </Box>
          )}
          MenuProps={MenuProps}
      >
          {options.map((option) => (
              <MenuItem
                  key={option}
                  value={option}
                  style={getStyles(option, selectedOption, theme)}
                  >
                  {option}
              </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
